import { CloseCircleIcon } from '@calizahq/react-components-v2'

export function Error() {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <CloseCircleIcon className="w-32 icon-semantic-error" />
      <h1 className="font-medium text-header-xxl">Error</h1>
      <p className="mt-4 font-medium">Whoops! Something went wrong.</p>
    </div>
  )
}
